import React, { useState } from 'react';
import classNames from 'classnames';
import i18n from '@i18next/i18n';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import styles from './slide-extra-buttons.less';
import { IAiReplaceSlidePCService, REPORT_LOCATION } from '@src/slide/application/service/ai-replace-slide/ai-replace-slide-service.interface';

interface IAddSlideCardProps {
    className: string;
    aiReplaceService?: Promise<IAiReplaceSlidePCService>
}

// 重新生成图片弹窗
export const SlideExtraButtons = ({ className, aiReplaceService }: IAddSlideCardProps) => {
    const [isCardShow, setIsCardShow] = useState(false);

    return (
        <div className={classNames(className, { [styles.forceShow]: isCardShow })}>
            <Tooltip title={i18n.t('AI 单页美化')}>
                <div
                    className={styles.extraButton}
                    onClick={() => {
                        setIsCardShow(true);
                        aiReplaceService?.then(s =>
                            s.showModal({
                                onClose: () => setIsCardShow(false),
                                location: REPORT_LOCATION.slideList,
                            }));
                    }}
                ></div>
            </Tooltip>
        </div>
    );
};
